import React from "react";
import styles from "./style.module.css";
import DownloadButton from "../DownloadButton";
import { images } from "../../assets/images";
const Banner = ({text , backgroundColor}) => {
  const { AppleBlack, PlayBlack } = images;
  return (
    <div className={styles.container} style={{backgroundColor: backgroundColor}}>
      <p className={styles.heading}>
       {text}
      </p>

      <div className={styles.btnContainer}>
        <DownloadButton
          text="Download on App Store"
          icon={AppleBlack}
          bgColor="#fff"
          textColor="#000"
          width="25px"
          height="25px"
        />
        <DownloadButton
          text="Download on Play Store"
          icon={PlayBlack}
          bgColor="#fff"
          textColor="#000"
        />
      </div>
    </div>
  );
};

export default Banner;
